import type { PublicSlotKey } from '#packages/apilib';
import type { StudioMigrationManagerApi } from './studioMigrationManagerApi';

export const StudioMigrationManagerKey: PublicSlotKey<StudioMigrationManagerApi> =
  {
    name: 'StudioMigrationManager',
    public: true,
  };
